import React, { ComponentType } from "react";

export function withProps<T>(Component: ComponentType<T>) {
    return (props: T) => (ownProps: T) => <Component {...props} {...ownProps} />;
}
